// extracted by mini-css-extract-plugin
export default {"AuthorLink":"CommitAttribution-module__AuthorLink--S0Z7k","CommitAttributionContainer":"CommitAttribution-module__CommitAttributionContainer--dZiJ_"};